import React from 'react';
import { Link } from 'react-router-dom';
import './header.css';

const navItems = [
	{ href: '/' },
	{ label: 'AKWABA', href: '/akwaba' },
	{ label: 'FORMATIONS', href: '/formations' },
	{ label: 'VIE UNIVERSITAIRE', href: '/vieUniversitaire' },
	{ label: 'ESPACE ETUDIANTS', href: '/espaceEtudiants' },
	{ label: 'CTIA', href: '/ctia' },
];

export default function Header() {
	return (
		<header className="site-header">
			<div className="top-bar">
				<div className="container">
					<Link to="/" className="logo">
						<img src="/images/logo-iusse.png" alt="Logo IUSSE" />
					</Link>
				</div>
			</div>

			<nav className="main-nav">
				<ul>
					{navItems.map((item) => (
						<li key={item.href}>
							<Link to={item.href}>{item.label}</Link>
						</li>
					))}
				</ul>
			</nav>
		</header>
	);
}
